import axios from 'axios';

export const productApi  = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-products`,
    headers: {
        'Content-Type': 'application/json'
    }
})